import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {Fournisseur} from '@domain/facture/fournisseur';
import {ListViewItem} from '@domain/common/list-view/list-view-item';
import {ListView} from '@domain/common/list-view';
import {FournisseursService} from "@services/admin/facture/fournisseurs.service";

/**
 * Composant d'affichage d'un item fournisseur dans une liste
 *
 * @author Yannick Gauthier
 * @date 15/07/2025
 */
@Component({
    selector: 'factures-fournisseurs-item',
    templateUrl: './factures-fournisseurs-item.component.html'
})
export class FacturesFournisseursItemComponent extends ListViewItem<Fournisseur> {
    /** Données du fournisseur */
    @Input() data: Fournisseur;

    /** Affichage/masquage de l'élément */
    @Input() toggleItem: (data: Fournisseur) => void;

    /**
     * Constructeur
     *
     * @param router Service de routage
     * @param fournisseurService Service de gestion des fournisseurs
     */
    constructor(private router: Router,
                public fournisseurService: FournisseursService) {
        super();
    }

    /**
     * Méthode appelée lors du clic sur l'item
     */
    onItemClick(): void {
        this.router.navigate(['Admin/Frais/Factures/Fournisseurs', this.data.idFournisseur]);
    }
}
